import { render, staticRenderFns } from "./FaqElement.vue?vue&type=template&id=173c44f6&scoped=true&"
import script from "./FaqElement.vue?vue&type=script&lang=js&"
export * from "./FaqElement.vue?vue&type=script&lang=js&"
import style0 from "./FaqElement.vue?vue&type=style&index=0&id=173c44f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173c44f6",
  null
  
)

export default component.exports